import { Outlet } from "react-router-dom";

import { NavigationDrawer } from "@src/components/Navigation/BaseSideNav/NavigationDrawer";

import { AppLayoutShell } from "./layout/AppLayoutShell";

export const StandardNoPaddingPageProvider = () => (
  <AppLayoutShell
    sideNav={<NavigationDrawer isUnauthorized={false} />}
    maxWidth="none"
  >
    <Outlet />
  </AppLayoutShell>
);
